/**
 * Example JavaScript singleton module
 */

var Sliders = (function($) {
  function initStudioSlider() {
    var studioGallerySlider = new Swiper(".studio-gallery-slider", {
      slidesPerView: "auto",
      spaceBetween: 40,
      grabCursor: true,
      freeMode: {
        enabled: true,
        momentum: true
      },
      mousewheel: {
        forceToAxis: true
      },
      speed: 800
    });
  }

  function initArticleSlider() {
    var articleSlider = new Swiper(".post-slider", {
      slidesPerView: "auto",
      spaceBetween: 40,
      grabCursor: true,
      freeMode: {
        enabled: true,
        momentum: true
      },
      mousewheel: {
        forceToAxis: true
      },
      speed: 800
    });
  }

  function initContactSlider() {
    var contactGallerySlider = new Swiper(".contact-team-slider", {
      slidesPerView: "auto",
      spaceBetween: 30,
      grabCursor: true,
      freeMode: {
        enabled: true,
        momentum: true
      },
      mousewheel: {
        forceToAxis: true
      },
      speed: 800
    });
  }

  function initOfficesSlider() {
    var contactOfficesSlider = new Swiper(".contact-offices-slider", {
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 800,
      grabCursor: true,

      pagination: {
        el: ".contact-offices-pagination",
        clickable: true
      }
    });
  }

  function initLocationsSlider() {
    const locationsHeroSlider = new Swiper(".locations-hero-slider", {
      slidesPerView: 1,
      loop: true,
      effect: "fade",

      fadeEffect: {
        crossFade: true
      },
      speed: 100,
      autoplay: {
        delay: 1400,
        disableOnInteraction: false,
        pauseOnMouseEnter: false
      },
      allowTouchMove: false
    });
  }

  function initPhotoMotionSlider() {
    const PhotoMotionSlider = new Swiper(".js-project-gallery", {
      slidesPerView: 1,
      loop: true,
      effect: "fade",
      fadeEffect: {
        crossFade: true
      },
      speed: 100,
      autoplay: {
        delay: 2000,
        disableOnInteraction: false,
        pauseOnMouseEnter: false
      },
      allowTouchMove: false
    });
  }

  function initCSR1Slider() {
    var CSR1Slider = new Swiper(".csr-slider-01", {
      slidesPerView: "auto",
      spaceBetween: 30,
      grabCursor: true,
      freeMode: {
        enabled: true,
        momentum: true
      },
      mousewheel: {
        forceToAxis: true
      },
      speed: 800
    });
  }

  function initCSR2Slider() {
    var CSR1Slider = new Swiper(".csr-slider-02", {
      slidesPerView: "auto",
      spaceBetween: 30,
      grabCursor: true,
      freeMode: {
        enabled: true,
        momentum: true
      },
      mousewheel: {
        forceToAxis: true
      },
      speed: 800
    });
  }

  function initCSR3Slider() {
    var CSR1Slider = new Swiper(".csr-slider-03", {
      slidesPerView: "auto",
      spaceBetween: 30,
      grabCursor: true,
      freeMode: {
        enabled: true,
        momentum: true
      },
      mousewheel: {
        forceToAxis: true
      },
      speed: 800
    });
  }

  function initCSR4Slider() {
    var CSR1Slider = new Swiper(".csr-slider-04", {
      slidesPerView: "auto",
      spaceBetween: 30,
      grabCursor: true,
      freeMode: {
        enabled: true,
        momentum: true
      },
      mousewheel: {
        forceToAxis: true
      },
      speed: 800
    });
  }

  function initCSR5Slider() {
    var CSR1Slider = new Swiper(".csr-slider-05", {
      slidesPerView: "auto",
      spaceBetween: 30,
      grabCursor: true,
      freeMode: {
        enabled: true,
        momentum: true
      },
      mousewheel: {
        forceToAxis: true
      },
      speed: 800
    });
  }

  function init() {
    // return early if no corresponding module present
    if (!$(".swiper").length) {
      return;
    }

    if ($(".page-template-template-studio-equipment").length) {
      initStudioSlider();
    }

    if ($(".page-template-template-contact").length) {
      initContactSlider();
      initOfficesSlider();
    }

    if ($(".page-template-template-locations").length) {
      initLocationsSlider();
    }

    if ($(".single-project").length) {
      initPhotoMotionSlider();
    }

    if ($(".single-post").length) {
      initArticleSlider();
    }

    if ($(".page-template-template-csr").length) {
      initCSR1Slider();
      initCSR2Slider();
      initCSR3Slider();
      initCSR4Slider();
      initCSR5Slider();
    }
  }

  return {
    init: init
  };
})(jQuery);

jQuery(document).ready(Sliders.init);
